import React, { useRef, useState } from 'react'
import { SearchOutlined } from '@ant-design/icons'
import { Checkbox, Dropdown, Radio, RadioChangeEvent } from 'antd'
import { CloseDropeDown } from 'helper/CloseDropdown'
import { StatusList } from '../constants'
import { capitalizeFirstLetter, clearFilters } from 'helper/utility'
import { CaretDown, Download, Ticket, UserPlus } from '@phosphor-icons/react'
import '../../../styles/checkin-out.scss'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import { debounce } from 'lodash'
import {
  AttendeeStatusParams,
  CheckInOutStatusTypes,
} from 'types/event/eventAttendance'

const ModalHeader = ({
  params,
  setParams,
  currentView,
  setView,
}: {
  params: AttendeeStatusParams
  setParams: React.Dispatch<React.SetStateAction<AttendeeStatusParams>>
  currentView: 'particpants' | 'roll-calls'
  setView: React.Dispatch<React.SetStateAction<'particpants' | 'roll-calls'>>
}) => {
  const [open, setOpen] = useState(0)
  const [selectedStatus, setSelectedStatus] = useState<CheckInOutStatusTypes[]>(
    [],
  )

  const {
    setDropInModalOpen,
    setCheckInOutModalOpen,
    setCheckInOutExportModalOpen,
    setParticipantData,
    setDropInAttendeeData,
    setRollCallModalOpen,
  } = eventAttendanceStore(store => ({
    dropInModalOpen: store.dropInModalOpen,
    setDropInModalOpen: store.setDropInModalOpen,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    setCheckInOutExportModalOpen: store.setCheckInOutExportModalOpen,
    setParticipantData: store.setParticipantData,
    setDropInAttendeeData: store.setDropInAttendeeData,
    setRollCallModalOpen: store.setRollCallModalOpen,
  }))

  const dropdownRef = useRef<HTMLDivElement | null>(null)
  const handleDropdownClick = CloseDropeDown({ dropdownRef, setOpen })

  const handleCheckboxChange = (key: any) => {
    setSelectedStatus(key)
  }

  const filteredStatusList = StatusList.filter(item => item.value !== 'pending')

  const Status = [
    {
      key: '1',
      label: (
        <Checkbox.Group onChange={handleCheckboxChange} value={selectedStatus}>
          {filteredStatusList.map(item => {
            return (
              <div key={item.key} className="flex mt-15px align-center">
                <Checkbox value={item.value} />
                <div
                  style={{ backgroundColor: `${item.color}` }}
                  className="flex px-15px py-10px radius-12 ml-10px"
                >
                  <img src={item.img} alt={item.title} />
                  <h4 className="ml-10px text-12 w-600">{item.title}</h4>
                </div>
              </div>
            )
          })}
        </Checkbox.Group>
      ),
    },
    {
      key: 2,
      label: (
        <div className="flex justify-between mx-15px">
          <button
            className="clr-btn"
            onClick={() => {
              setParams({ ...params, statuses: [] })
              setSelectedStatus([])
              setOpen(0)
            }}
          >
            Clear
          </button>
          <button
            onClick={() => {
              setParams({ ...params, statuses: selectedStatus })
              setOpen(0)
            }}
            className="aply-btn"
          >
            Apply
          </button>
        </div>
      ),
    },
  ]

  const viewFilter = [
    {
      key: '1',
      label: (
        <Radio.Group
          options={[
            { label: 'Particpants', value: 'particpants' },
            { label: 'Roll-calls', value: 'roll-calls' },
          ]}
          className="dropdwn checkbox"
          value={currentView}
          style={{
            display: 'flex',
            flexDirection: 'column',
          }}
          onChange={(val: RadioChangeEvent) => {
            setView(val.target.value)
            setOpen(0)
          }}
        />
      ),
    },
    {
      key: 'btns',
      label: (
        <div className="flex justify-between mx-15px">
          <button className="clr-btn">Clear</button>
          <button
            onClick={() => {
              setOpen(0)
            }}
            className="aply-btn"
          >
            Apply
          </button>
        </div>
      ),
    },
  ]

  const moreOptions = [
    {
      key: '1',
      label: (
        <>
          <div
            className="flex align-center gap-10px"
            onClick={() => setCheckInOutExportModalOpen(true)}
          >
            <Download size={16} color="#000" /> Export
          </div>
        </>
      ),
    },
  ]

  const handleDropInClick = () => {
    setDropInAttendeeData(null)
    setParticipantData(null)
    setDropInModalOpen(true)
    setCheckInOutModalOpen(false)
  }

  const handleRollCallClick = () => {
    setDropInAttendeeData(null)
    setParticipantData(null)
    setRollCallModalOpen(true)
    setCheckInOutModalOpen(false)
  }

  const actionsOptions = [
    {
      key: '1',
      label: (
        <>
          <div
            className="flex align-center gap-10px"
            onClick={handleDropInClick}
          >
            <UserPlus size={16} color="#000" /> Drop in
          </div>
        </>
      ),
    },
    {
      key: '2',
      label: (
        <>
          <div
            className="flex align-center gap-10px"
            onClick={handleRollCallClick}
          >
            <Ticket size={16} color="#000" /> Roll call
          </div>
        </>
      ),
    },
  ]

  const hanldeStatusClick = () => {
    setSelectedStatus(params.statuses)
    open === 1 ? setOpen(0) : setOpen(1)
  }

  const handleSearch = (e: string) => {
    setParams({ ...params, searchQuery: e })
  }

  const debounced = debounce(handleSearch, 500)

  return (
    <>
      <div className="flex justify-between my-20px">
        <div className="flex align-center ">
          <div className="search-input-box w-fit">
            <input
              type="search"
              className="search-input-group "
              placeholder="Search"
              style={{ width: '350px' }}
              onChange={e => {
                e.preventDefault()
                debounced(e.target.value)
              }}
            />
            <SearchOutlined />
          </div>

          <div
            ref={dropdownRef}
            onClick={handleDropdownClick}
            className="flex align-center"
          >
            <Dropdown
              menu={{
                items: Status,
              }}
              placement="bottomLeft"
              arrow={false}
              className=" mr-10px"
              open={open === 1}
              overlayStyle={{ width: '300px' }}
            >
              <button
                className={` ${
                  open === 1 ? 'filter-btn-click ' : 'filter-btn'
                } ${params.statuses?.length ? 'applied' : ''} w-500`}
                onClick={hanldeStatusClick}
              >
                Status <CaretDown />
              </button>
            </Dropdown>
            <Dropdown
              menu={{
                items: viewFilter,
              }}
              placement="bottomLeft"
              arrow={false}
              className="ml-20px mr-10px"
              open={open === 2}
              overlayStyle={{ width: '250px' }}
            >
              <button
                className={` ${
                  open === 2 ? 'filter-btn-click ' : 'filter-btn'
                } w-500`}
                onClick={() => setOpen(2)}
              >
                {capitalizeFirstLetter(currentView)} <CaretDown />
              </button>
            </Dropdown>
          </div>
        </div>

        <div className="flex align-center gap-20px">
          <Dropdown menu={{ items: moreOptions }} trigger={['click']}>
            <button className="button btn-borderless-gray">
              More <CaretDown size={22} color="#000" />
            </button>
          </Dropdown>

          <Dropdown menu={{ items: actionsOptions }} trigger={['click']}>
            <button className="button btn-primary-bordered">
              Actions <CaretDown size={22} color="#2BA7CA" />
            </button>
          </Dropdown>
        </div>
      </div>
    </>
  )
}

export default ModalHeader
